module.exports = __webpack_public_path__ + "img/杨文生.c3bbee91.jpg";